import env from "./env.js";
import common from "@/utils/common.js";

const ENV_BASE_URL = {
  development: "http://192.168.234.109:58080/activity-api", //开发环境
  // development: "https://newfb.nbwbw.com/activity-api", //开发环境
  production: "https://newfb.nbwbw.com/activity-api",
};

const ENV_PHP_URL = {
  development: "https://apptest.nbwbw.com", //开发环境
  production: "https://apptest.nbwbw.com",
};

const getEnv = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/micromessenger/i) == "micromessenger") {
    return env.WX;
  }
  if (ua.includes("yonglian")) {
    return env.YS;
  }
  if (ua.includes("yongpai")) {
    return env.YP;
  }
  return env.WEB;
};
// 获取key和默认分享链接
// const params = common.getRequestParams();
// const key = params.get("key") || "";
// console.log(params);
// const key = params.key || "";
// 环境
const currentEnv = getEnv();
const PHP_API_VERSION = currentEnv === env.YP ? "9.0.0" : "6.0.0";
export default {
  BASE_URL: ENV_BASE_URL[process.env.NODE_ENV || "development"],
  PHP_URL: ENV_PHP_URL[process.env.NODE_ENV || "development"],
  env: currentEnv, // 当前环境
  // 当前环境
  isYs: currentEnv === env.YS,
  isWx: currentEnv === env.WX,
  isWeb: currentEnv === env.WEB,
  isYp: currentEnv === env.YP,
  isAndroid: navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Linux") > -1,
  isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
  PHP_API_VERSION,
  WX_APPID: "wxadf0be5030743d5c",
  VUEX_STORAGE_KEY: "xin-2024-qingming",
};
